import api from "../client";
import {
  malnutritionUseMocks,
  mockGetMalnutritionRiskAssessment,
  mockGetPatientWeights,
  mockSetMalnutritionFeedback,
} from "./mocks";

import type {
  MalnutritionRiskAssessment,
  PatientWeightHistory,
} from "../../types/Malnutrition";

export const getMalnutritionRiskAssessment = async (
  emrPatientID: string,
  emrHospitalID: string,
): Promise<MalnutritionRiskAssessment> => {
  if (malnutritionUseMocks())
    return mockGetMalnutritionRiskAssessment(emrPatientID);
  const response = await api.get("/patient-malnutrition/", {
    params: { emr_patient_id: emrPatientID, emr_hospital_id: emrHospitalID },
  });
  return response?.data;
};

export const getPatientWeights = async (
  emrPatientID: string,
  emrHospitalID: string,
): Promise<PatientWeightHistory> => {
  if (malnutritionUseMocks()) return mockGetPatientWeights(emrPatientID);
  const response = await api.get("/patient-recent-weights/", {
    params: { emr_patient_id: emrPatientID, emr_hospital_id: emrHospitalID },
  });
  return response?.data;
};

export const postMalnutritionFeedback = async (
  emrPatientID: string,
  emrHospitalID: string,
  isGoodCandidate: boolean,
): Promise<void> => {
  // In mock mode there's no backend to persist to; record it locally so the
  // read-back reflects it, then acknowledge without a network call.
  if (malnutritionUseMocks()) {
    mockSetMalnutritionFeedback(isGoodCandidate);
    return;
  }
  await api.post("/patient-malnutrition-feedback/", {
    emr_patient_id: emrPatientID,
    emr_hospital_id: emrHospitalID,
    is_good_candidate: isGoodCandidate,
  });
};
